import axios from "axios";

export class GameKillerService {
    async activeGameKiller(spaceId: number): Promise<any> {
        return await axios.post(`api/spaces/${spaceId}/assassin_game/start`, {});
    }
    async disableGameKiller(spaceId: number): Promise<any> {
        return await axios.post(`api/spaces/${spaceId}/assassin_game/finish`, {});
    }
    async killPlayerGameKiller(spaceUserId: number): Promise<any> {
        return await axios.post(`api/space_users/${spaceUserId}/assassin_game/kill_player`, {});
    }
    async reportPlayerGameKiller(spaceUserId: number, data: any): Promise<any> {
        return await axios.post(`api/space_users/${spaceUserId}/assassin_game/report_player`, data);
    }
    async votePlayerGameKiller(spaceId: number, data: any): Promise<any> {
        return await axios.post(`api/spaces/${spaceId}/assassin_game/vote_player`, data);
    }
}